import classNames from "classnames";

import FilesCountersContainer from "../FilesCountersContainer";
import { ReactComponent as IconPictures } from "@assets/ic_picture.svg";
import { ReactComponent as IconVideos } from "@assets/ic_video.svg";
import { ReactComponent as IconAudios } from "@assets/ic_audio.svg";
import { ReactComponent as IconDotSeparator } from "@assets/ic_dot-separator.svg";
import { ReactComponent as IconTexts } from "@assets/ic_text-posts.svg";
import { ReactComponent as IconLive } from "@assets/ic_live.svg";

import styles from "./index.module.scss";
import { Fragment } from "react";

const FilesCounters = ({
  videos = 0,
  images = 0,
  audios = 0,
  iconsSize = 22,
  containerStyles,
  textType = "text-body-2",
  showTextIcon,
  children,
  colorClassName = "text-white",
  isStream,
}) => {
  const noMediaFiles = images === 0 && videos === 0 && audios === 0;

  const config = [
    {
      Icon: IconPictures,
      count: images,
    },
    {
      Icon: IconVideos,
      count: videos,
    },
    {
      Icon: IconAudios,
      count: audios,
    },
  ].filter(({ count }) => count > 0);

  if (isStream) {
    return (
      <FilesCountersContainer containerStyles={containerStyles}>
        <div className="d-flex align-items-center">
          <IconLive
            className={classNames(colorClassName, styles.icon)}
            width={iconsSize}
            height={iconsSize}
          />
          <span className={classNames(textType, colorClassName)}>1</span>
        </div>
      </FilesCountersContainer>
    );
  }

  if (showTextIcon && noMediaFiles) {
    return (
      <FilesCountersContainer containerStyles={containerStyles}>
        <IconTexts
          className={classNames(colorClassName, styles.icon)}
          width={iconsSize}
          height={iconsSize}
        />
      </FilesCountersContainer>
    );
  }

  if (noMediaFiles) {
    return null;
  }

  return (
    <>
      <FilesCountersContainer containerStyles={containerStyles}>
        {children}

        {config.map(({ Icon, count }, index) => {
          const isLast = config.length - 1 === index;
          return (
            <Fragment key={index + "filesCountersItem"}>
              <div className="d-flex align-items-center">
                <Icon
                  className={classNames(colorClassName, styles.icon)}
                  width={iconsSize}
                  height={iconsSize}
                />
                <span className={classNames(textType, colorClassName)}>
                  {count}
                </span>
              </div>
              {!isLast && (
                <IconDotSeparator
                  className={classNames(styles.dotSeparator, colorClassName)}
                />
              )}
            </Fragment>
          );
        })}
      </FilesCountersContainer>
    </>
  );
};

export default FilesCounters;
